module.exports = __webpack_public_path__ + "static/media/experience.5795a1b1.svg";